import { render, staticRenderFns } from "./DashboardLendingByAge.vue?vue&type=template&id=22c7d048"
import script from "./DashboardLendingByAge.vue?vue&type=script&lang=js"
export * from "./DashboardLendingByAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports